import { render, staticRenderFns } from "./inheritRecord.vue?vue&type=template&id=75a7de09&scoped=true&"
import script from "./inheritRecord.vue?vue&type=script&lang=js&"
export * from "./inheritRecord.vue?vue&type=script&lang=js&"
import style0 from "./inheritRecord.vue?vue&type=style&index=0&id=75a7de09&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a7de09",
  null
  
)

export default component.exports